import { render, staticRenderFns } from "./QRStep.vue?vue&type=template&id=1e228778"
import script from "./QRStep.vue?vue&type=script&lang=js"
export * from "./QRStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports